import { render, staticRenderFns } from "./REFID.vue?vue&type=template&id=7a98603c"
import script from "./REFID.vue?vue&type=script&lang=js"
export * from "./REFID.vue?vue&type=script&lang=js"
import style0 from "./REFID.vue?vue&type=style&index=0&id=7a98603c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports